type Options = {
  maxPollNumber?: number;
  timeoutTime?: number;
};

export const onGlobalVarSet = <T>(
  varName: string,
  options: Options = {},
): Promise<T> => {
  const maxPollNumber = options.maxPollNumber || 40;
  const timeoutTime = options.timeoutTime || 400;
  let pollNumber = 0;

  return new Promise((resolve, reject) => {
    const intervalId = setInterval(() => {
      if (window[varName]) {
        clearInterval(intervalId);
        resolve(window[varName]);
      } else if (pollNumber > maxPollNumber) {
        reject(`Cannot reach plugin ${varName}`);
      } else {
        pollNumber = pollNumber + 1;
      }
    }, timeoutTime);
  });
};
